import { FilterField, useSubdivisionOptions } from "~/features/filter";

import { useDealerOptions } from "./useDealerOptions";
import { usePermissionOptions } from "./usePermissionOptions";
import { useRoleOptions } from "./useRoleOptions";
import { useStatusOptions } from "./useStatusOptions";

type Translate = (key: string) => string;

/**
 * Описание полей формы фильтрации списка пользователей.
 * Имена полей соответствуют ключам `userListFilterIProps`, чтобы
 * их можно было напрямую передавать в API.
 */
export const usersFilterFields = (t: Translate): FilterField[] => [
  {
    name: "id",
    type: "input",
    label: t("users.id"),
  },
  {
    name: "fullName",
    type: "input",
    label: t("users.fullname"),
  },
  {
    name: "searchText",
    type: "input",
    label: t("users.login"),
  },
  {
    name: "position",
    type: "input",
    label: t("users.position"),
  },
  {
    name: "email",
    type: "input",
    label: t("users.email"),
  },
  {
    name: "phone",
    type: "input",
    label: t("users.phone"),
  },
  {
    name: "dealerIds",
    type: "select",
    label: t("users.dealer"),
    optionsHook: useDealerOptions,
    multiple: true,
  },
  {
    name: "status",
    type: "select",
    label: t("users.status"),
    optionsHook: useStatusOptions,
  },
  {
    name: "roleNames",
    type: "select",
    label: t("users.role"),
    optionsHook: useRoleOptions,
    multiple: true,
    span: 2,
  },
  {
    name: "permissionIds",
    type: "select",
    label: t("users.permissions"),
    optionsHook: usePermissionOptions,
    multiple: true,
    span: 2,
  },
  {
    name: "subdivisionIds",
    type: "select",
    label: t("users.subdivision"),
    optionsHook: useSubdivisionOptions,
    multiple: true,
  },
];
